import { defineComponent as _defineComponent } from 'vue'
import { AssigneeReference, AuthorityType, Client, Permission } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authStore';
import { computed, ref, watch } from 'vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { getServices } from '@/app/services';
import { useRoute, useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySingleClientView',
  props: { clientId: { type: String, required: true } },
  setup(__props) {

const props = __props;



const client = ref<Client>();

const clientPermissions = ref<Permission[]>([]);

const clientAssignees = ref<AssigneeReference[]>([]);

const requestManager = useRequestManager().manager;

const services = getServices();

const authStore = useAuthStore();

const route = useRoute();

const router = useRouter();

function onClientIdChange() {
  requestManager
    .sameOrCancelAndNew('getClientPermissions', services.authz.getClientsPermissions(props.clientId))
    .subscribe((response) => (clientPermissions.value = response));

  requestManager
    .sameOrCancelAndNew('getClient', services.client.getClient(props.clientId), props.clientId)
    .subscribe((response) => (client.value = response));

  requestManager
    .sameOrCancelAndNew('getAssignees', services.client.getClientAssignees(props.clientId), props.clientId)
    .subscribe((response) => (clientAssignees.value = response));
}

const requestStates = computed(() => Object.values(requestManager.requestStates));

const OBOallowed = computed(() => {
  if (client.value) {
    if (!authStore.authorities.includes(AuthorityType.ACT_ON_BEHALF_OF)) {
      return false;
    } else if (!authStore.isAdminUser) {
      const assignee = clientAssignees.value.find(
        (assignee) => assignee.individual.id === authStore.loggedInUser!.individual!.id
      );
      return !!assignee;
    }
    return true;
  }
  return false;
});

/**
 * Whether we are on a child view, and should return to the root of the Activity Single Client view,
 * rather than back to the list of Clients
 *
 * This expects the first child route (and ONLY the first child route) to have the `rootChild` meta value set to true
 */
const onChildView = computed(() => {
  return !route.matched[route.matched.length - 1].meta.rootChild;
});

function go(back: boolean) {
  if (back) {
    const append = onChildView.value ? '/' + props.clientId : '';
    router.push({ path: `/admin/activity/clients${append}` });
  } else {
    router.push({ path: `/admin/activity/clients/obo/${props.clientId}` });
  }
}

watch(() => props.clientId, onClientIdChange, { immediate: true });

return { __sfc: true,props, client, clientPermissions, clientAssignees, requestManager, services, authStore, route, router, onClientIdChange, requestStates, OBOallowed, onChildView, go }
}

})